<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- action -->
			<div style="font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="名称"
					>
					</el-table-column>
					<el-table-column
						prop="code"
						label="激活码"
					>
					</el-table-column>
					<el-table-column
						prop="productName"
						label="产品"
					>
					</el-table-column>
					<el-table-column
						prop="times"
						label="次数"
					>
					</el-table-column>
					<el-table-column
						prop="statusName"
						label="是否已消费"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="200"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增激活卡 -->
		<Popup 
			v-model="add_display"
			title="新增激活卡"
			confirmBtnText="添加"
			@confirmClick="handleAddPopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>名称</span>
					<el-input v-model="add_name" placeholder="名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addName_tip"><i class="b_icon"></i>请输入名称</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>激活码</span>
					<el-input v-model="add_code" placeholder="激活码"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addCode_tip"><i class="b_icon"></i>请输入激活码</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>产品</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="add_products" @change="handleAddProductsChange">
							<el-checkbox v-for="v in authProduct" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addProducts_tip"><i class="b_icon"></i>请至少选择一项</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>次数</span>
					<el-input v-model="add_times" placeholder="次数"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addTimes_tip"><i class="b_icon"></i>输入次数格式有误</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>是否已消费</span>
					<div class="b_checkbox_group">
						<el-radio-group v-model="add_consume">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</div>
				</div>
			</div>
		</Popup>
		<!-- 新增激活卡 end -->
		
		<!-- 修改激活卡 -->
		<Popup 
			v-model="update_display"
			title="修改激活卡"
			confirmBtnText="确定"
			@confirmClick="handleUpdatePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>名称</span>
					<el-input v-model="update_name" placeholder="名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateName_tip"><i class="b_icon"></i>请输入名称</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>激活码</span>
					<el-input v-model="update_code" placeholder="激活码"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateCode_tip"><i class="b_icon"></i>请输入激活码</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>产品</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="update_products" @change="handleUpdateProductsChange">
							<el-checkbox v-for="v in authProduct" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateProducts_tip"><i class="b_icon"></i>请至少选择一项</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>次数</span>
					<el-input v-model="update_times" placeholder="次数"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateTimes_tip"><i class="b_icon"></i>输入次数格式有误</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>是否已消费</span>
					<div class="b_checkbox_group">
						<el-radio-group v-model="update_consume">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</div>
				</div>
			</div>
		</Popup>
		<!-- 修改激活卡 end -->
		
		<!-- 删除弹出框 -->
		<Popup
			v-model="delete_display"
			title="提示"
			@confirmClick="handleDeletePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<p style="color: #5f6468;line-height: 24px;">您确认要删除该条吗？</p>
			</div>
		</Popup>
		<!-- 删除弹出框 end -->
	</div>
</template>

<script>
	import Api from '../../../../api/index.js'
	import { mapState } from 'vuex'
	
	export default {
		mounted () {
			this.getList();
		},
		data () {
			return {
				loading: false,
				tableData: [],
				currentPage: 1,
				total: 0,
				
				add_display: false,
				add_name: '',
				add_code: '',
				add_products: [],
				add_times: 1,
				add_consume: 0,
				addName_tip: false,
				addCode_tip: false,
				addProducts_tip: false,
				addTimes_tip: false,
				
				update_display: false,
				update_id: '',
				update_name: '',
				update_code: '',
				update_products: [],
				update_times: 1,
				update_consume: 0,
				updateName_tip: false,
				updateCode_tip: false,
				updateProducts_tip: false,
				updateTimes_tip: false,
				
				delete_display: false,
				delete_id: ''
			}
		},
		computed: {
			...mapState(['authProduct'])
		},
		methods: {
			/********************************* @Events *********************************/
			// 点击新增
			handleAddClick () {
				this.add_name = '';
				this.add_code = '';
				this.add_products = [];
				this.add_times = 1;
				this.add_consume = 0;
				this.addName_tip = false;
				this.addCode_tip = false;
				this.addProducts_tip = false;
				this.addTimes_tip = false;
				this.add_display = true;
			},
			// 新增产品选择
			handleAddProductsChange () {
				var proIndex = this.add_products.indexOf(1),
					funIndex = this.add_products.indexOf(0);
				if (proIndex > -1 && funIndex > -1) {
					var minIndex = proIndex < funIndex ? proIndex : funIndex;
					this.add_products.splice(minIndex, 1);
				}
			},
			// 点击新增弹框确定按钮
			handleAddPopupConfirmClick () {
				if (!this.add_name.trim()) {
					this.addName_tip = true;
					return false;
				} else {
					this.addName_tip = false;
				}
				if (!this.add_code.trim()) {
					this.addCode_tip = true;
					return false;
				} else {
					this.addCode_tip = false;
				}
				if (!this.add_products.length) {
					this.addProducts_tip = true;
					return false;
				} else {
					this.addProducts_tip = false;
				}
				if (!this.positiveReg.test(this.add_times)) {
					this.addTimes_tip = true;
					return false;
				} else {
					this.addTimes_tip = false;
				}
				this.addCard();
			},
			
			// 点击修改
			handleUpdateClick (obj) {
				this.update_id = obj.id;
				this.update_name = obj.name;
				this.update_code = obj.code;
				this.update_products = obj.productId.split(',');
				this.update_times = obj.times;
				this.update_consume = obj.status;
				this.updateName_tip = false;
				this.updateCode_tip = false;
				this.updateProducts_tip = false;
				this.updateTimes_tip = false;
				this.update_display = true;
			},
			// 修改产品选择
			handleUpdateProductsChange () {
				var proIndex = this.update_products.indexOf(1),
					funIndex = this.update_products.indexOf(0);
				if (proIndex > -1 && funIndex > -1) {
					var minIndex = proIndex < funIndex ? proIndex : funIndex;
					this.update_products.splice(minIndex, 1);
				}
			},
			// 点击修改弹框确定按钮
			handleUpdatePopupConfirmClick () {
				const that = this;
				if (!this.update_name.trim()) {
					this.updateName_tip = true;
					return false;
				} else {
					this.updateName_tip = false;
				}
				if (!this.update_code.trim()) {
					this.updateCode_tip = true;
					return false;
				} else {
					this.updateCode_tip = false;
				}
				if (!this.update_products.length) {
					this.updateProducts_tip = true;
					return false;
				} else {
					this.updateProducts_tip = false;
				}
				if (!this.positiveReg.test(this.update_times)) {
					this.updateTimes_tip = true;
					return false;
				} else {
					this.updateTimes_tip = false;
				}
				that.$confirm(
					'此操作将修改该激活卡?', 
					'提示', 
					{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.updateCard();
					}
				);
			},
			
			// 页码改变
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			
			// 点击删除
			handleDeleteClick (obj) {
				this.delete_id = obj.id;
				this.delete_display = true;
			},
			// 点击删除弹出框确认按钮
			handleDeletePopupConfirmClick () {
				const that = this;
				that.loading = true;
				var requestData = {
					id: that.delete_id
				};
				Api.deleteActiveCard(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.delete_display = false;
						that.$message.success(res.data.message);
						that.currentPage = 1;
						that.getList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			/********************************* @Function *********************************/
			// 请求数据
			getList () {
				const that = this;
				that.loading = true;
				var requestData = {
					limit: 10,
					pageNum: that.currentPage,
					type: 1
				};
				Api.findActiveCard(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.tableData = [];
						for (var i = 0;i < res.data.data.data.length;i++) {
							var _o = res.data.data.data[i],
								_productId = _o.productId.split(','),
								_productName = '';
							for (var ww = 0;ww < _productId.length;ww++) {
								for (var ii = 0;ii < that.authProduct.length;ii++) {
									that.authProduct[ii].id == _productId[ww]
										&& (_productName += `${ that.authProduct[ii].name },`);
								}
							}
							_productName 
								&& (_productName = _productName.slice(0, _productName.length - 1));
							that.tableData.push({
								id: _o.id,
								name: _o.cardName || '',
								code: _o.codeId || '',
								productId: _o.productId || '',
								productName: _productName,
								times: _o.times || 1,
								status: _o.status,
								statusName: _o.status == 0 ? '否' : '是'
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 新增激活卡
			addCard () {
				const that = this;
				that.loading = true;
				var requestData = {
					cardName: that.add_name,
					codeId: that.add_code,
					id: null,
					productId: that.add_products.join(','),
					status: that.add_consume,
					times: that.add_times,
					userId: null
				};
				Api.addActiveCard(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.add_display = false;
						that.$message.success(res.data.message);
						that.getList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 修改激活卡
			updateCard () {
				const that = this;
				that.loading = true;
				var requestData = {
					cardName: that.update_name,
					codeId: that.update_code,
					id: that.update_id,
					productId: that.update_products.join(','),
					status: that.update_consume,
					times: that.update_times,
					userId: null
				};
				Api.updateActiveCard(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.update_display = false;
						that.$message.success(res.data.message);
						that.getList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		}
	}
</script>

<style scoped>
	.back_tools_manage{ position: relative;width: 100%;height: 100%;padding: 15px; }
	.back_tools_manage .scroller{ width: 100%;height: 100%;padding: 15px;background: #fff;overflow-x: hidden;overflow-y: auto; }
</style>
